module.exports = __webpack_public_path__ + "static/media/papel.f948e914.png";